import { apiCall } from './gqlClient';
const GETCUSTOMERS_QUERY = "\n  query getCustomers($notArchived: Boolean, $active: Boolean, $isApproved: Boolean) {\n    getCustomers(notArchived: $notArchived, active: $active, isApproved: $isApproved)\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n\t\t\tcompletedOnboarding\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getCustomersApiCall = async function (_ref) {
  let {
    notArchived,
    active,
    isApproved
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETCUSTOMERS_QUERY,
    variables: {
      notArchived,
      active,
      isApproved
    },
    fragments
  });
};
const GETPROVIDERBLACKLISTEDUSERS_QUERY = "\n  query getProviderBlacklistedUsers {\n    getProviderBlacklistedUsers\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n\t\t\tcompletedOnboarding\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const getProviderBlacklistedUsersApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETPROVIDERBLACKLISTEDUSERS_QUERY,
    variables: {},
    fragments
  });
};
const GETUSERPROFILEINFOFORCOPY_QUERY = "\n  query getUserProfileInfoForCopy($id: Int!) {\n    getUserProfileInfoForCopy(id: $id)\n    {\n      codiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\taddress\n\t\t\tbirthday\n\t\t\tphone\n\t\t\tcountry\n\t\t\temail\n\t\t\tgender\n      ...fragments\n    }\n  }";
export const getUserProfileInfoForCopyApiCall = async function (_ref2) {
  let {
    id
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERPROFILEINFOFORCOPY_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETINACTIVECUSTOMERS_QUERY = "\n  query getInactiveCustomers {\n    getInactiveCustomers\n    {\n      id\n\t\t\tcustomerId\n\t\t\tname\n\t\t\temail\n\t\t\tfirstname\n\t\t\tlastname\n      ...fragments\n    }\n  }";
export const getInactiveCustomersApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETINACTIVECUSTOMERS_QUERY,
    variables: {},
    fragments
  });
};
const GETUSERSASSIGNEDTOPRODUCT_QUERY = "\n  query getUsersAssignedToProduct($productId: String!) {\n    getUsersAssignedToProduct(productId: $productId)\n    {\n      id\n\t\t\tcustomerId\n\t\t\tname\n\t\t\temail\n\t\t\tfirstname\n\t\t\tlastname\n      ...fragments\n    }\n  }";
export const getUsersAssignedToProductApiCall = async function (_ref3) {
  let {
    productId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERSASSIGNEDTOPRODUCT_QUERY,
    variables: {
      productId
    },
    fragments
  });
};
const GETARCHIVEDCUSTOMERS_QUERY = "\n  query getArchivedCustomers {\n    getArchivedCustomers\n    {\n      id\n\t\t\tuserId\n\t\t\temail\n\t\t\tname\n\t\t\tarchivedRole\n\t\t\tarchivedDate\n      ...fragments\n    }\n  }";
export const getArchivedCustomersApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETARCHIVEDCUSTOMERS_QUERY,
    variables: {},
    fragments
  });
};
const GETCUSTOMERINVITATIONFLOW_QUERY = "\n  query getCustomerInvitationFlow($customerFlowId: String!) {\n    getCustomerInvitationFlow(customerFlowId: $customerFlowId)\n  }";
export const getCustomerInvitationFlowApiCall = async _ref4 => {
  let {
    customerFlowId
  } = _ref4;
  return apiCall({
    query: GETCUSTOMERINVITATIONFLOW_QUERY,
    variables: {
      customerFlowId
    }
  });
};
const GETCUSTOMERPERSONALINFORMATION_QUERY = "\n  query getCustomerPersonalInformation($customerId: Int!, $userId: Int!) {\n    getCustomerPersonalInformation(customerId: $customerId, userId: $userId)\n  }";
export const getCustomerPersonalInformationApiCall = async _ref5 => {
  let {
    customerId,
    userId
  } = _ref5;
  return apiCall({
    query: GETCUSTOMERPERSONALINFORMATION_QUERY,
    variables: {
      customerId,
      userId
    }
  });
};
const GETCUSTOMERFLOWINFORMATION_QUERY = "\n  query getCustomerFlowInformation($customerId: Int!, $customerFlowId: String!) {\n    getCustomerFlowInformation(customerId: $customerId, customerFlowId: $customerFlowId)\n  }";
export const getCustomerFlowInformationApiCall = async _ref6 => {
  let {
    customerId,
    customerFlowId
  } = _ref6;
  return apiCall({
    query: GETCUSTOMERFLOWINFORMATION_QUERY,
    variables: {
      customerId,
      customerFlowId
    }
  });
};
const CREATECUSTOMERWALKIN_QUERY = "\n  mutation createCustomerWalkIn($name: String!, $note: String, $email: String, $phone: String, $svcGroupId: String, $lastname: String) {\n    createCustomerWalkIn(name: $name, note: $note, email: $email, phone: $phone, svcGroupId: $svcGroupId, lastname: $lastname)\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n\t\t\tcompletedOnboarding\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const createCustomerWalkInApiCall = async function (_ref7) {
  let {
    name,
    note,
    email,
    phone,
    svcGroupId,
    lastname
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATECUSTOMERWALKIN_QUERY,
    variables: {
      name,
      note,
      email,
      phone,
      svcGroupId,
      lastname
    },
    fragments
  });
};
const CREATECUSTOMER_QUERY = "\n  mutation createCustomer($request: CustomerInput!) {\n    createCustomer(request: $request)\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n\t\t\tcompletedOnboarding\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const createCustomerApiCall = async function (_ref8) {
  let {
    request
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATECUSTOMER_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CONVERTWALKININTOCUSTOMER_QUERY = "\n  mutation convertWalkinIntoCustomer($id: Int!, $name: String!, $email: String!) {\n    convertWalkinIntoCustomer(id: $id, name: $name, email: $email)\n    {\n      id\n\t\t\tresourceId\n\t\t\townerId\n\t\t\townerIds\n\t\t\tname\n\t\t\tfirstname\n\t\t\tlastname\n\t\t\tfullname\n\t\t\tgender\n\t\t\tbirthday\n\t\t\taddress\n\t\t\tcity\n\t\t\tpostcode\n\t\t\tcountry\n\t\t\ttags\n\t\t\turl\n\t\t\tfacebook\n\t\t\tphone\n\t\t\temail\n\t\t\trole\n\t\t\tcode\n\t\t\tcodeExpiration\n\t\t\tactive\n\t\t\timage\n\t\t\tstatus\n\t\t\tproviderId\n\t\t\tprovidersIds\n\t\t\tuserLanguage\n\t\t\tblacklisted\n\t\t\tblockContent\n\t\t\tdescribedName\n\t\t\tnote\n\t\t\tcodiceFiscale\n\t\t\tpiva\n\t\t\tsdi\n\t\t\tcreated\n\t\t\tordersNumber\n\t\t\tcustomerId\n\t\t\tsvcGroupId\n\t\t\tgroupColor\n\t\t\tcompletedOnboarding\n\t\t\ttimezone\n      ...fragments\n    }\n  }";
export const convertWalkinIntoCustomerApiCall = async function (_ref9) {
  let {
    id,
    name,
    email
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CONVERTWALKININTOCUSTOMER_QUERY,
    variables: {
      id,
      name,
      email
    },
    fragments
  });
};
const CREATEVISITATOREFROMCSV_QUERY = "\n  mutation createVisitatoreFromCSV($customers: JSON!, $svcGroupId: String) {\n    createVisitatoreFromCSV(customers: $customers, svcGroupId: $svcGroupId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createVisitatoreFromCSVApiCall = async function (_ref0) {
  let {
    customers,
    svcGroupId
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEVISITATOREFROMCSV_QUERY,
    variables: {
      customers,
      svcGroupId
    },
    fragments
  });
};
const CREATEUSERSFROMCSV_QUERY = "\n  mutation createUsersFromCSV($customers: JSON!, $svcGroupId: String) {\n    createUsersFromCSV(customers: $customers, svcGroupId: $svcGroupId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createUsersFromCSVApiCall = async function (_ref1) {
  let {
    customers,
    svcGroupId
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEUSERSFROMCSV_QUERY,
    variables: {
      customers,
      svcGroupId
    },
    fragments
  });
};
const TOGGLEUSERBLACKLISTSTATUS_QUERY = "\n  mutation toggleUserBlacklistStatus($userId: Int!, $blacklisted: Boolean!) {\n    toggleUserBlacklistStatus(userId: $userId, blacklisted: $blacklisted)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const toggleUserBlacklistStatusApiCall = async function (_ref10) {
  let {
    userId,
    blacklisted
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLEUSERBLACKLISTSTATUS_QUERY,
    variables: {
      userId,
      blacklisted
    },
    fragments
  });
};
const BLOCKUSER_QUERY = "\n  mutation blockUser($userId: Int!, $blockContent: Boolean!) {\n    blockUser(userId: $userId, blockContent: $blockContent)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const blockUserApiCall = async function (_ref11) {
  let {
    userId,
    blockContent
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: BLOCKUSER_QUERY,
    variables: {
      userId,
      blockContent
    },
    fragments
  });
};
const UNBLOCKUSER_QUERY = "\n  mutation unblockUser($userId: Int!) {\n    unblockUser(userId: $userId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const unblockUserApiCall = async function (_ref12) {
  let {
    userId
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UNBLOCKUSER_QUERY,
    variables: {
      userId
    },
    fragments
  });
};
const TOGGLEBLOCKEDUSERCONTENT_QUERY = "\n  mutation toggleBlockedUserContent($userId: Int!, $blockContent: Boolean!) {\n    toggleBlockedUserContent(userId: $userId, blockContent: $blockContent)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const toggleBlockedUserContentApiCall = async function (_ref13) {
  let {
    userId,
    blockContent
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLEBLOCKEDUSERCONTENT_QUERY,
    variables: {
      userId,
      blockContent
    },
    fragments
  });
};
const UPDATECUSTOMERGROUP_QUERY = "\n  mutation updateCustomerGroup($id: Int!, $svcGroupId: String) {\n    updateCustomerGroup(id: $id, svcGroupId: $svcGroupId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateCustomerGroupApiCall = async function (_ref14) {
  let {
    id,
    svcGroupId
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATECUSTOMERGROUP_QUERY,
    variables: {
      id,
      svcGroupId
    },
    fragments
  });
};
const UPDATECUSTOMER_QUERY = "\n  mutation updateCustomer($customer: NormalCustomerUpdateInput!) {\n    updateCustomer(customer: $customer)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateCustomerApiCall = async function (_ref15) {
  let {
    customer
  } = _ref15;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATECUSTOMER_QUERY,
    variables: {
      customer
    },
    fragments
  });
};
const UPDATEWALKINCUSTOMER_QUERY = "\n  mutation updateWalkInCustomer($walkinCustomer: WalkinCustomerUpdateInput!) {\n    updateWalkInCustomer(walkinCustomer: $walkinCustomer)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateWalkInCustomerApiCall = async function (_ref16) {
  let {
    walkinCustomer
  } = _ref16;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEWALKINCUSTOMER_QUERY,
    variables: {
      walkinCustomer
    },
    fragments
  });
};
const COPYDATAFROMPROFILE_QUERY = "\n  mutation copyDataFromProfile($id: Int!) {\n    copyDataFromProfile(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const copyDataFromProfileApiCall = async function (_ref17) {
  let {
    id
  } = _ref17;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: COPYDATAFROMPROFILE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const REMOVECUSTOMER_QUERY = "\n  mutation removeCustomer($id: Int!) {\n    removeCustomer(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const removeCustomerApiCall = async function (_ref18) {
  let {
    id
  } = _ref18;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REMOVECUSTOMER_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const RESTORECUSTOMER_QUERY = "\n  mutation restoreCustomer($id: Int!) {\n    restoreCustomer(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const restoreCustomerApiCall = async function (_ref19) {
  let {
    id
  } = _ref19;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTORECUSTOMER_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const REINVITEINACTIVECUSTOMERS_QUERY = "\n  mutation reinviteInactiveCustomers($inactiveCustomers: [InactiveUserInput]!, $flowId: String) {\n    reinviteInactiveCustomers(inactiveCustomers: $inactiveCustomers, flowId: $flowId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const reinviteInactiveCustomersApiCall = async function (_ref20) {
  let {
    inactiveCustomers,
    flowId
  } = _ref20;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REINVITEINACTIVECUSTOMERS_QUERY,
    variables: {
      inactiveCustomers,
      flowId
    },
    fragments
  });
};
const COMPLETECUSTOMERINVITATIONFLOW_QUERY = "\n  mutation completeCustomerInvitationFlow($customerFlowId: String!) {\n    completeCustomerInvitationFlow(customerFlowId: $customerFlowId)\n  }";
export const completeCustomerInvitationFlowApiCall = async _ref21 => {
  let {
    customerFlowId
  } = _ref21;
  return apiCall({
    query: COMPLETECUSTOMERINVITATIONFLOW_QUERY,
    variables: {
      customerFlowId
    }
  });
};